import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { useIntersection } from "../../Hooks/customHooks";
import { START_GET_SURGERY_FIELD_LIST } from "../../Actions/PatientAction";
import {
  CircularProgress,
  Grid,
  TextField,
  Checkbox,
  Chip,
  Box,
  Button,
} from "@mui/material";
import clsx from "clsx";
import "../../Sass/Common.scss";
import Autocomplete from "@mui/material/Autocomplete";
import { getEllipsisName } from "../../utils/generalUtils";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  SurgeryAutocompleteListbox: {
    padding: "0px !important",
    // marginTop: "45px !important",
  },
  addButton: {
    "&>button": {
      fontSize: "1rem",
      overflow: "hidden",
      [theme.breakpoints.between("1600", "1700")]: {
        fontSize: "0.9rem",
      },
      [theme.breakpoints.between("1500", "1600")]: {
        fontSize: "0.85rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
      },
      [theme.breakpoints.between("1400", "1500")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        // height:"40px"
      },
      [theme.breakpoints.between("1300", "1400")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        // height:"45px"
      },
      [theme.breakpoints.between("1200", "1300")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "38px",
      },
      [theme.breakpoints.between("1100", "1200")]: {
        fontSize: "0.7rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
      },
    },
  },
  customTag:{
    maxWidth: "calc(60% - 6px) !important"
  }
}));

function SurgeryAutoComplete(props) {
  const {
    value,
    multiple,
    disabled,
    handleChange,
    surgeryFieldList,
    getSurgeryListAction,
    apiParams,
    disableEnter = true,
    maxValue,
    surgeryListFlag,
    helperText,
    error = false,
    maxVisibleChip = 1,
    isOpenSurgeyAutocomplete,
    setIsOpenSurgeyAutocomplete,
    buttonOptionTop,
    buttonTitle,
    handleButtonClick,
    textFieldProps = {
      required: true,
    },
    ...other
  } = props;
  const classes = useStyles();
  const [selectSurgery, setSelectSurgery] = useState(
    multiple ? Object?.values(value || {}) : value || {}
  );
  const [surgerySearchString, setSurgerySearchString] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [setTargetSurgery, entrySurgery] = useIntersection({ threshold: 0.1 });
  const query = new URLSearchParams(window.location.search);

  /** get value */
  useEffect(() => {
    if (multiple) {
      setSelectSurgery(Object?.values(value || {}));
    } else {
      setSelectSurgery(value);
    }
  }, [value]);
  useEffect(() => {
    if (query.get("actionType") === "create") {
      if (isOpenSurgeyAutocomplete) {
        setIsOpen(true);
        setIsOpenSurgeyAutocomplete(false);
      }
    }
  }, [isOpenSurgeyAutocomplete]);
  /** get entry surgery  */
  useEffect(() => {
    if (entrySurgery.isIntersecting && surgeryFieldList.loading === false) {
      let params = {
        offset: surgeryFieldList?.data?.list?.length || 0,
        ...(surgerySearchString && { q: surgerySearchString }),
      };
      if (isOpen) {
        getSurgeryListAction(params);
      }
    }
  }, [entrySurgery]);

  /** search surgery */
  const searchSurgeryDebounce = useRef(
    _.debounce((searchString, open) => {
      let params = {
        offset: 0,
      };
      if (searchString) {
        params.q = searchString;
      }
      if (open) {
        getSurgeryListAction(params);
      }
    }, 500)
  );

  /** handle surgery search */
  const handleSurgerySearch = (newValue) => {
    setSurgerySearchString(newValue);
    searchSurgeryDebounce.current(newValue, isOpen);
  };

  /** fetch surgery */
  let fetchSurgery = () => {
    setIsOpen(true);
    let params = {
      offset: 0,
      ...(surgerySearchString && { q: surgerySearchString }),
    };

    getSurgeryListAction(params);
  };

  /** handle change surgery list */
  const handleChangeSurgeryList = (event, newValue) => {
    let newList = {};
    if (multiple) {
      newValue.map((surgery) => {
        newList[surgery.id] = surgery;
      });
    } else {
      newList = newValue;
    }
    setSelectSurgery(newValue);
    handleChange && handleChange(newList);
  };

  /** Filter options with a custom button at the top of the list */
  const filterOptions = (options) => {
    let result = [...options];
    if (buttonOptionTop && !result.some((option) => option.type === "button")) {
      result = [{ type: "button" }, ...result];
    }
    if (surgeryFieldList?.data?.list?.length < surgeryFieldList?.data?.total) {
      result.push("FinalOption");
    }
    if (surgeryFieldList?.data?.list?.length === 0) {
      result.push({
        name: `No option found`,
      });
    }
    return result || [];
  };

  return (
    <>
      <Autocomplete
        multiple={multiple}
        onKeyDown={(event) => {
          event.stopPropagation();
        }}
        limitTags={2}
        classes={{
          listbox: buttonOptionTop && classes.SurgeryAutocompleteListbox,
          option: "option",
          noOptions: "noOptions",
          tag: classes.customTag,
        }}
        disableCloseOnSelect={multiple}
        disabled={Boolean(disabled)}
        onOpen={fetchSurgery}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        loading={""}
        noOptionsText={fetchSurgery}
        value={selectSurgery}
        onChange={handleChangeSurgeryList}
        options={surgeryFieldList?.data?.list || []}
        getOptionLabel={(option) => {
          return option.name || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return option?.id === value?.id;
        }}
        onInputChange={(event, newValue) => {
          handleSurgerySearch(newValue);
        }}
        filterOptions={filterOptions}
        renderOption={(props, option, { selected }) => {
          if (buttonOptionTop && option.type === "button") {
            return (
              <Grid
                container
                alignItems="center"
                className={clsx("autoCompleteButton", classes.addButton)}
              >
                <Button
                  onClick={handleButtonClick}
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  {buttonTitle}
                </Button>
              </Grid>
            );
          } else {
            return (
              <React.Fragment>
                {typeof option === "object" ? (
                  <Grid {...props} key={option?.id}>
                    {multiple && option.id && <Checkbox checked={selected} />}
                    {option.name}
                  </Grid>
                ) : (
                  <Grid
                    className="autoCompleteInputLoader"
                    ref={setTargetSurgery}
                  >
                    <CircularProgress size={20} />
                  </Grid>
                )}
              </React.Fragment>
            );
          }
        }}
        getOptionDisabled={(option) => {
          if (option.name === "No option found") {
            return true;
          }
        }}
        renderTags={(tagValue, getTagProps) => {
          if (tagValue.length === maxVisibleChip) {
            return tagValue.map((option, index) => {
              return (
                <HtmlTooltipMain title={option?.name}>
                  <Chip
                    key={index}
                    label={`${option.name}`}
                    {...getTagProps({ index })}
                    size="small"
                  />
                </HtmlTooltipMain>
              );
            });
          } else {
            return (
              <Box display="flex" alignItems="center">
                {tagValue
                  .slice(
                    0,
                    surgeryListFlag === true ? maxValue : maxVisibleChip
                  )
                  .map((option, index) => (
                    <HtmlTooltipMain title={tagValue[index]?.name}>
                      <Chip
                        label={`${getEllipsisName(tagValue[index].name, 10)}`}
                        {...getTagProps({ index: index })}
                        size="small"
                      />
                    </HtmlTooltipMain>
                  ))}
                {tagValue.length > maxVisibleChip && (
                  <HtmlTooltipMain
                    interactive={true}
                    title={
                      <Grid>
                        {tagValue.slice(maxVisibleChip).map((option, index) => (
                          <Box>{option.name}</Box>
                        ))}
                      </Grid>
                    }
                  >
                    <Box>
                      +{" "}
                      {tagValue.length -
                        Math.min(maxVisibleChip, tagValue.length)}{" "}
                      more
                    </Box>
                  </HtmlTooltipMain>
                )}
              </Box>
            );
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            helperText={helperText}
            InputLabelProps={{ required: false }}
            // {...textFieldProps}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
              endAdornment: (
                <React.Fragment>
                  {surgeryFieldList?.loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        {...other}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  surgeryFieldList: state.patient.surgeryFieldList,
});

const mapDispatchToProps = (dispatch) => ({
  getSurgeryListAction: (payload) =>
    dispatch({ type: START_GET_SURGERY_FIELD_LIST, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurgeryAutoComplete);
